import React from 'react';
import { Hero } from '../components/Hero';
import { Manifesto } from '../components/Manifesto';
import { SocialProofOpener } from '../components/SocialProofOpener';
import { PainPoints } from '../components/PainPoints';
import { FinalCTA } from '../components/FinalCTA';
export function HomePage() {
  return <>
      <Hero data-id="element-544" />
      <Manifesto data-id="element-545" />
      <SocialProofOpener data-id="element-546" />
      <PainPoints data-id="element-547" />
      <FinalCTA data-id="element-548" />
    </>;
}